export default "__VITE_ASSET__CGnPE0hh__"